export default "__VITE_ASSET__3JJCm8i1__"